import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import {jwtDecode, JwtPayload} from 'jwt-decode';

interface CustomJwtPayload extends JwtPayload {
    instance?: Array<{ domain: string, ip: string }>;
}

function isJwtTokenFormatValid(token: unknown): token is string {
    return typeof token === 'string'
        && token !== ''
        && token !== 'undefined'
        && token !== 'null'
        && token.split('.').length === 3
}

function getJwtToken(): string | null {
    const token = localStorage.getItem('jwt_token')
    return isJwtTokenFormatValid(token) ? token : null
}

export const axiosAuth: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        'X-Client-Panel-Host': window.location.host
    }
})

export function getInstance(): string | undefined {
    const token = getJwtToken();
    if (!token) {
        console.error('JWT token not found in localStorage');
        return undefined;
    }

    try {
        const decodedToken: CustomJwtPayload = jwtDecode(token)

        if (decodedToken.instance && decodedToken.instance.length > 0) {
            return decodedToken.instance[0].domain;
        } else {
            console.error('Instance array is empty or not defined in the JWT token');
            return undefined;
        }
    } catch (error) {
        console.error('Error decoding JWT token:', error);
        return undefined;
    }
}

export const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
});

axiosInstance.interceptors.request.use((config) => {
    const token = getJwtToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['X-Client-Panel-Host'] = window.location.host;
    return config;
}, (error) => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use((response: AxiosResponse) => {
    return response;
}, (error: AxiosError) => {
    if (error.response?.status === 404) {
        console.error('Company ID unavailable, not refreshing token');
    }

    return Promise.reject(error);
});

export default { axiosAuth, axiosInstance }
